import axios from 'axios';

/**
 * Compute the API base URL.
 *
 * Strategy:
 *   • In the Emergent preview environment we use the value baked in
 *     `process.env.REACT_APP_BACKEND_URL` (this is how the workspace
 *     hot-reloads against the preview backend).
 *   • In every other environment (custom domain, Vercel, etc.) we use
 *     **same-origin** `/api`. This means the browser always hits the
 *     backend that's served from the same host as the UI — eliminating
 *     dead/abandoned hardcoded URLs (e.g. an old `*.emergent.host`)
 *     baked into a previous production build.
 */
const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const isPreviewEnv = /preview\.emergentagent\.com$/.test(
  (typeof window !== 'undefined' && window.location.hostname) || ''
);
export const BACKEND_URL = isPreviewEnv ? ENV_BACKEND : (ORIGIN || ENV_BACKEND);
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
